import * as api from '../../api/api';
import * as types from '../constants/profileConstants';
import { browserHistory } from 'react-router';
import _ from 'underscore';

export function getTradingHours(clientId, merchantId) {
	return function (dispatch) {
		dispatch({ type: types.GET_TRADING_HOURS });
	
		api.get(`profile/client/${clientId}/merchant/${merchantId}/tradingHours`)
			.then(function (response) {
				dispatch(updateTradingHours(response));
			}).catch(function () {
				browserHistory.push('/contactus/errorDetailed/105');
			});
	};
}

export function getMerchants(mobileNumber, clientId = "") {
	return function (dispatch) {
		dispatch({ type: types.GET_MERCHANTS });

		api.get(`profile/merchants/${mobileNumber}?clientId=${clientId}`)
			.then(function (response) {
				dispatch(getMerchantsSuccess(response));
			}).catch(function() {
				browserHistory.push('/contactus/errorDetailed/107');
			});
	}
}

export function getMerchantsSuccess(response) {
	return {
		type: types.GET_MERCHANTS_SUCCESS,
		response: response
	};
}

export function updateTradingHours(hours) {
	return {
		type: types.UPDATE_TRADING_HOURS,
		hours: hours
	};
}

export function postTradingHours(clientId, terminalId, tradingHours) {
	return function (dispatch) {
		dispatch({ type: types.POST_TRADING_HOURS });
		
		api.post(`profile/client/${clientId}/terminal/${terminalId}/tradingHours`, _.toArray(tradingHours))
			.then(function () {
				dispatch(postTradingHoursSuccess());
			}).catch(function () {
				browserHistory.push('/contactus/errorDetailed/106');
			});
	};
}

export function postTradingHoursSuccess() {
	return {
		type: types.POST_TRADING_HOURS_SUCCESS
	};
}


// WEBPACK FOOTER //
// ./app/profile/actions/profileActions.js